import React from "react";
import {
  Facebook,
  Twitter,
  Mail,
  Link as LinkIcon,
  Share2,
  X,
  MessageCircle,
} from "lucide-react";

interface Props {
  open: boolean;
  onClose: () => void;
  url: string;
  title: string;
}

export default function ShareModal({ open, onClose, url, title }: Props) {
  if (!open) return null;

  const encodedURL = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shares = [
    {
      name: "Facebook",
      icon: <Facebook size={26} />,
      color: "text-blue-500",
      onClick: () =>
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`,
          "_blank"
        ),
    },
    {
      name: "Twitter/X",
      icon: <Twitter size={26} />,
      color: "text-sky-400",
      onClick: () =>
        window.open(
          `https://twitter.com/intent/tweet?url=${encodedURL}&text=${encodedTitle}`,
          "_blank"
        ),
    },
    {
      name: "Zalo",
      icon: <MessageCircle size={26} />,
      color: "text-blue-400",
      onClick: () =>
        window.open(
          `https://zalo.me/share?url=${encodedURL}`,
          "_blank"
        ),
    },
    {
      name: "WhatsApp",
      icon: <MessageCircle size={26} />,
      color: "text-green-400",
      onClick: () =>
        window.open(`https://api.whatsapp.com/send?text=${encodedURL}`, "_blank"),
    },
    {
      name: "Email",
      icon: <Mail size={26} />,
      color: "text-red-400",
      onClick: () =>
        (window.location.href = `mailto:?subject=${encodedTitle}&body=${encodedURL}`),
    },
    {
      name: "Copy Link",
      icon: <LinkIcon size={26} />,
      color: "text-gray-300",
      onClick: () => {
        navigator.clipboard.writeText(url);
        alert("Link copied!");
      },
    },
  ];

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-xl z-[200] flex items-center justify-center">
      <div className="bg-[#0f1628] border border-white/10 p-8 rounded-3xl max-w-lg w-full mx-4 shadow-xl text-white relative">

        {/* Close Button */}
        <button className="absolute top-4 right-4 text-gray-300 hover:text-white" onClick={onClose}>
          <X size={28} />
        </button>

        <h2 className="text-2xl font-bold mb-6 text-center">Share this article</h2>
        <p className="text-gray-400 text-sm mb-6 text-center break-all">{url}</p>

        <div className="grid grid-cols-3 gap-6 text-center">
          {shares.map((s) => (
            <button
              key={s.name}
              onClick={s.onClick}
              className="flex flex-col items-center gap-2 p-4 hover:bg-white/10 rounded-xl transition"
            >
              <span className={`${s.color}`}>{s.icon}</span>
              <span className="text-sm">{s.name}</span>
            </button>
          ))}
        </div>

        <button
          className="w-full mt-8 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl flex items-center justify-center gap-2"
          onClick={() => {
            if (navigator.share) {
              navigator.share({ title, url });
            } else {
              navigator.clipboard.writeText(url);
              alert("Link copied!");
            }
          }}
        >
          <Share2 size={20} /> System Share
        </button>
      </div>
    </div>
  );
}
